import React, {useState, useEffect} from "react";
import { BASE_URL } from "../../../constants";
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Row, Col, Container, Card, Button, Form, InputGroup } from 'react-bootstrap';
import '../../../CommonCSS/SocietyCSS.css';
import "jspdf-autotable";
import { exportCashBankExcel } from "./ExportCashBankExcel";
import { exportCashBankPDF } from "./ExportCashBankPDF";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

/*
 npm install file-saver
*/
const CashBank_Book = () => {

  const today = new Date().toISOString().split("T")[0];

  const [ddlSectionId, setDdlSectionId] = useState();
  const [paramCB_Code, setParamCB_Code] = useState();
  const [paramFromDate, setParamFromDate] = useState(today);
  const [paramToDate, setParamToDate] = useState(today);

  const [societyName, setSocietyName] = useState();
  const [cashBankList, setCashBankList] = useState([]);
  const [ddlSections, setDdlSections] = useState([]);
  const [cbBookData, setCBBookData] = useState([]);
  const [groupedData, setGroupedData] = useState({});

  useEffect(() => {

    const fetchLists = async () => {
      try {
        const [cashBankRes, SectionRes] = await Promise.all([
          axios.get(`${BASE_URL}/api/ddl_CashBank_Mast`),
          axios.get(`${BASE_URL}/api/ddl_sections`),
        ]);

        setCashBankList(cashBankRes.data);
        setDdlSections(SectionRes.data);

      } catch (err) {
        console.error("Dropdown fetch error:", err);
      }
    };

    fetchLists();

  }, []);

  const handleRunReport = async () => {

    try {

      if (!paramFromDate || paramFromDate === '') {
        toast.error('Please enter From Date.');
        return;
      } else if (!paramToDate || paramToDate === '') {
        toast.error('Please enter To Date.');
        return;
      } else if (paramFromDate > paramToDate) {
        toast.error('From Date cannot be grater than To Date.');
        return;
      } else if (!ddlSectionId || ddlSectionId === '') {
        toast.error('Please select Section.');
        return;
      }

      const cashbankBookRes = await axios.get(`${BASE_URL}/api/rpt_cashbank_book`,
        { params: { p_Section_Id: ddlSectionId, p_CBCode: paramCB_Code || 0, p_FromDate: paramFromDate, p_ToDate: paramToDate } });

      if (cashbankBookRes.data.length > 0) {
        const grpData = groupDataOnBankName(cashbankBookRes.data);
        setCBBookData(cashbankBookRes.data);
        setGroupedData(grpData);
        setSocietyName(cashbankBookRes.data[0].scty_name);
      } else {
        setGroupedData({});
        toast.error('No Record available');
      }

    } catch (error) {
     toast.error('Error Cash/Bank Book : ', error);
   }
 
  };

  const groupDataOnBankName = (completedata) => {
    return completedata.reduce((acc, result) => {
      const { bank_name } = result;
      if (!acc[bank_name]) {
        acc[bank_name] = [];
      }
      acc[bank_name].push(result);
      return acc;
    }, {});
  };

  function formatCurrency(amount) {
    const numberFormat = new Intl.NumberFormat('en-IN', {
      style: 'decimal', //'currency',
      minimumFractionDigits: 2,
      currency: 'INR',
      currencyDisplay: 'symbol',
    });
    return numberFormat.format(amount);
  }

  /// Export to Excel
  const handleDownloadExcel = () => {

    exportCashBankExcel({
      groupedData,
      fromDate: paramFromDate,
      toDate: paramToDate,
      societyName,
    });

  };

  /// download PDF
  const handleDownloadPDF = () => {

    exportCashBankPDF({
      groupedData,
      fromDate: paramFromDate,
      toDate: paramToDate,
      societyName,
    });

  };

  return (
    <Container fluid className="p-3">
      {/* Header Section */}
      <Card className="mb-3 p-2">

        <Row className="mt-3">
          <Col md={6}>
            <InputGroup>
              <InputGroup.Text style={{ width: "120px" }}>Cash/Bank</InputGroup.Text>
              <Form.Select className="form-select" name="paramCB_Code" value={paramCB_Code}
                onChange={(e) => setParamCB_Code(e.target.value)}  >
                <option value="">-- Select Cash/Bank --</option>
                {cashBankList.map((cb) => (
                  <option key={cb.cb_code} value={cb.cb_code}>
                    {cb.cb_name}
                  </option>
                ))}
              </Form.Select>
            </InputGroup>
          </Col>

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text>From Date</InputGroup.Text>
            <input
              type="date" style={{textAlign: 'right'}}
              className="form-control"
              value={paramFromDate}
              onChange={(e) => setParamFromDate(e.target.value)}
            />
            </InputGroup>
          </Col>

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text>To Date</InputGroup.Text>
            <input
              type="date" style={{textAlign: 'right'}}
              className="form-control"
              value={paramToDate}
              onChange={(e) => setParamToDate(e.target.value)}
            />
            </InputGroup>
          </Col>

        </Row>

        <Row className="mt-3">

          <Col md={4}>
            <InputGroup >
              <InputGroup.Text>Section</InputGroup.Text>
              <select className="form-select" name="ddlSectionId" value={ddlSectionId}
                onChange={(e) => setDdlSectionId(e.target.value)} >
                <option value="">-- Select Section --</option>
                {ddlSections.map(sec => (
                  <option key={sec.section_id} value={sec.section_id}>{sec.section_desc}</option>
                ))}
              </select>
            </InputGroup>
          </Col>

          <Col md={8} className="d-flex justify-content-end">

            <Button style={{height: '40px', width: '145'}} className="me-2" variant="secondary" 
                    onClick={handleDownloadExcel} disabled={cbBookData.length === 0}>Download Excel</Button>

            <Button style={{height: '40px', width: '135'}} className="me-2" variant="warning" 
                    onClick={handleDownloadPDF} disabled={cbBookData.length === 0}>Download PDF</Button>

            <Button style={{height: '40px', width: '135'}} className="me-2" variant="success" 
                    onClick={handleRunReport} >Run Report</Button>
            
          </Col>
        </Row>

        {/* <Row className="mt-3">
          <Col md={12} className="d-flex justify-content-end">
            <Button className="me-2" variant="success" onClick={handleRunReport} >Run Report</Button>
            <Button className="me-2" variant="warning" onClick={handleDownloadPDF} disabled={dayBookData.length === 0}>PDF File</Button>
          </Col>
        </Row> */}

      </Card>

      {/* Details Table */}
      <Card className="p-3">
        <div style={{ minHeight: '380px' }} className="table-responsive">
          <table style={{ maxHeight: '35px' }}  className="responsive-table scty-custom-table-rcpt hover-table-rcpt">
            <thead className="table-light">
              <tr>
                <th style={{ textAlign: 'center', width: '7%' }}>Vchr No</th>
                <th style={{ textAlign: 'center', width: '7%' }}>Date</th>
                <th style={{ textAlign: 'left', width: '21%' }}>Payer/Payee</th>
                <th style={{ textAlign: 'left', width: '24%' }}>Narration</th>
                <th style={{ textAlign: 'right', width: '10%' }} className="text-end">Debit Amount</th>
                <th style={{ textAlign: 'right', width: '10%' }} className="text-end">Credit Amount</th>
                <th style={{ textAlign: 'right', width: '10%' }} className="text-end">Closing Bal.</th>
              </tr>
            </thead>
            <tbody>
              {Object.keys(groupedData).map((bank_name) => (
                <React.Fragment key={bank_name}>
                  <tr style={{ border: '1px solid black' }}>
                    {/* , backgroundColor: '#f0f0f0'  */}
                    <td colSpan="7" style={{ fontWeight: 'bold', height: '5px' }}>
                      {bank_name}
                    </td>
                  </tr>
                  {groupedData[bank_name].map((result, index) => (
                    <tr key={index} style={{ height: '20px', border: '1px solid black', 
                        fontWeight: result.narration === 'Closing Balance' || result.narration === 'Opening Balance'  ? 'bold' : 'normal',
                        backgroundColor: result.narration === 'Closing Balance' ? '#f3f3f3' : 'white' }}>
                      <td style={{ textAlign: 'center'}}>{result.vchr_no}</td>
                      <td>{result.vchr_date}</td>
                      <td>{result.payer_payee}</td>
                      <td style={{ width: '40px' }} className='wrap-text'>{result.narration}</td>
                      <td style={{ textAlign: 'right' }}>{formatCurrency(result.dr_amt)}</td>
                      <td style={{ textAlign: 'right' }}>{formatCurrency(result.cr_amt)}</td>
                      <td style={{ textAlign: 'right' }}>{result.close_bal} </td>
                    </tr>
                  ))}
                </React.Fragment>
              ))}

            </tbody>
          </table>
        </div>

      </Card>
    </Container>
  );
};

export default CashBank_Book;
